<template>
  <div class="index-main">
    <Header/>
    <div class="carousel-box">
      <div class="carousel">
        <el-carousel trigger="click" height="465px">
          <el-carousel-item v-for="(item,index) in bannerData" :key="index">
            <img class="carousel-item-img" :src="item.image" alt="">
          </el-carousel-item>
        </el-carousel>
        <div class="main-1200-width">
          <div class="index-menu">
            <div class="index-menu-top">全部商品</div>
            <div class="index-menu-main">
              <div class="index-menu-item el-icon el-icon-arrow-right" v-for="(item1,index1) in menuData" :key="index1">
                <router-link :to="{path: 'Screen', name: 'Screen', params: {cate_id: item1.id}}">{{ item1.name }}</router-link>
                <div class="index-menu-item-more">
                  <div class="index-menu-more-item" v-for="(item2,index2) in item1.children" :key="index2">
                    <span>
                      <router-link class="index-menu-more-item-title" :to="{path: 'Screen', name: 'Screen', params: {cate_id: item2.id}}">{{ item2.name }}</router-link>
                    </span>
                    <span v-for="(item3,index3) in item2.children" :key="index3">
                      <router-link :to="{path: 'Screen', name: 'Screen', params: {cate_id: item3.id}}">{{ item3.name }}</router-link>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-1200-width padding-bottom-40">
      <div class="index-column" v-for="(item,index) in indexData" :key="index">
        <div class="index-column-header">
          <div class="index-column-title"><span>{{ item.name }}</span></div>
          <div class="index-column-desc">{{ item.desc }}</div>
        </div>
        <div class="flool-cle index-column-main">
          <div class="sellers sell_ons" v-for="(item2,index2) in item.goods" :key="index2" v-if="index2 < 1">
            <div class="best">
              <div class="best-about">
                <div class="best_img best_img2">
                  <a :href="'/GoodsDetail?id='+item2.id"><img :src="$url.cdn(item2.image)" :alt="item2.title"></a>
                </div>
                <div class="best_name">
                  <a :href="'/GoodsDetail?id='+item2.id"><span>{{ item2.title }}</span></a>
                </div>
                <div class="best_Introduction">
                  <div class="intr-t">{{ item2.subtitle }}</div>
                  <div class="intr-b">{{ item2.desc }}</div>
                </div>
                <div class="price" v-if="is_login">
                  <span>¥</span><em>{{ formatPrice(item2.price) }}</em>
                </div>
                <div class="price" v-else>
                  价格：**** <a href="/login">登录后查看</a>
                </div>
                <div class="imm-button">
                  <a :href="'/GoodsDetail?id='+item2.id"><span>立即抢购</span></a>
                </div>
                <div class="tag" v-if="item2.sales > 10">
                  <img src="@/assets/hot.png" alt="热卖">
                </div>
              </div>
            </div>
          </div>
          <div class="sellers sellers2" v-for="(item2,index2) in item.goods" :key="index2" v-if="index2 > 0">
            <div class="best">
              <div class="best-about">
                <div class="best_img best_img2 best_img3">
                  <a :href="'/GoodsDetail?id='+item2.id"><img :src="$url.cdn(item2.image)" :alt="item2.title"></a>
                </div>
                <div class="intr-t intr-t3">{{ item2.title }}</div>
                <div class="price prices" v-if="is_login">
                  <span>¥</span><em>{{ formatPrice(item2.price) }}</em>
                </div>
                <div class="price prices" v-else>
                  价格：**** <a href="/login">登录后查看</a>
                </div>
                <div class="tag">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import Header from "@/globalComponents/Header";
import Footer from "@/globalComponents/Footer";
import categoryApi from "@/api/category.js";
import appApi from "@/api/app.js";
import goodsApi from "@/api/goods.js";
export default {
  data() {
    return {
      active: 0,
      menuData: [],
      indexData: [],
      bannerData: [],
    };
  },
  computed: {
    ...mapGetters(['is_login']),
  },
  created() {
    this.getData();  //step1
  },
  methods: {
    formatPrice(e) {
        return e.length === 1 ? e[0] : e.join('~');
    },
    //step1:获取数据
    async getData() {
      let {data: bannerData} = await appApi.getSlideList()
      this.bannerData = bannerData;

      let {data: menuData} = await categoryApi.list()
      this.menuData = menuData.children || []

      await this.getIndexData()
    },
    async getIndexData() {
      let indexData = []
      // this.menuData.forEach(async item => {
      //   let {data} = await goodsApi.list({ category_id: item.id, list_rows: 19 })

      //   indexData.push({
      //     name: item.name,
      //     description: item.description,
      //     id:item.id,
      //     goods: data.data
      //   })
      // })
      let {data} = await categoryApi.indexData()
      this.indexData = data
    }
  },
  components: {
    Header,
    Footer
  }
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue